import React from 'react';
import moment from 'moment';
import { MCDatePicker } from '../complex';
import { Avatar, CloseBtn, MCButton } from '../basic';
import BaseComponent from '../BaseComponent';
import { BASE_ICONS } from '../svg';

import constants from 'src/constants';

import {
  addressObject,
  lang,
  remCss,
  userFullName
} from 'src/helpers';

class SlotCalendar extends BaseComponent {
  componentDidMount() {
    this.getModel().subscribe(this.subscription);
  }

  getModel = () => this.props.model;

  componentWillUnmount() {
    this.getModel().unsubscribe(this.subscription);
  }
  render() {
    const { model, onBookAppointment } = this.props;
    return (
      <>
        <MCDatePicker
          style={{ padding: 0, width: remCss(380) }}
          selected={model.input('selectedDate')}
          isMedium={true}
          minDate={moment()}
          onChange={model.selectedDay}
          onSetMonth={model.selectedMonth}
          onClassNamesOfCell={(day, classNames) => {
            if (
              model.state.slotsMonth.find(
                (s) =>
                  s.startDate >= day.clone().startOf('day') &&
                  s.startDate <= day.clone().endOf('day')
              )
            ) {
              classNames.push('available');
            }
          }}
        />
        <div className={'mc-flex-20-col'}>
          <div className={'mc-value-518'}>{lang.t('Time')}</div>
          <div className={'mc-flex-10-col'}>
            {model.state.slots
              .slice(0, this.state.more ? model.state.slots.length : 5)
              .map((s) => {
                const slot =
                  s.id !== model.state.selectedSlot?.id
                    ? s
                    : {
                        ...model.state.selectedSlot,
                        patientId: 'temp',
                        firstName: model.state.firstName || '',
                        lastName: model.state.lastName || ''
                      };
                const appointmentTypes = slot.appointmentType
                  ? [slot.appointmentType]
                  : slot.appointmentTypes;
                const appointmentType = slot.appointmentType || slot.appointmentTypes[0];
                const address = addressObject({ cityAddress: slot.cityAddress });
                return (
                  <div className={'mc-flex-10-col'} key={slot.id}>
                    <div className={'mc-value-518'}>{moment(slot.startDate).format('hh:mm a')}</div>
                    <div className={'mc-slot ' + appointmentType}>
                      {slot.patientId === 'temp' && (
                        <CloseBtn
                          onClose={() => model.setState({ selectedSlot: null })}
                          width={20}
                          style={{ position: 'absolute', right: remCss(15), top: remCss(15) }}
                        />
                      )}
                      <div className={'mc-flex-10'}>
                        {constants.general.appointment_types
                          .filter((i) => appointmentTypes.includes(i.value))
                          .map((i) => (
                            <div className={'mc-tag ' + i.value} key={i.value}>
                              {lang.t(i.label)}
                            </div>
                          ))}

                        {!slot.patientId && (
                          <button
                            type={'button'}
                            className={'mc-no-style-btn'}
                            onClick={() => onBookAppointment(slot)}
                          >
                            <span>{lang.t('Book appointment')}</span>
                          </button>
                        )}
                      </div>

                      {!!slot.patientId && (
                        <div className={'mc-flex-10'}>
                          <Avatar
                            image={slot.avatar}
                            text={slot.firstName}
                            width={54}
                            height={54}
                          />
                          <div className={'mc-value-518'}>{userFullName(slot)}</div>
                        </div>
                      )}
                      {slot.hospital && (
                        <div className={'mc-value-416'}>
                          {slot.hospital?.split('_')[0]}, {address.cityName}, {address.countryName}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            {model.state.slots.length > 5 && (
              <div className={'mc-flex'}>
                <div className={'mc-grow'}></div>
                <MCButton
                  small
                  primary
                  iconname={!this.state.more ? BASE_ICONS.PLUS : BASE_ICONS.MINUS}
                  onClick={() => this.setState({ more: !this.state.more })}
                  label={lang.t(!this.state.more ? 'Show more' : 'Show less')}
                />
              </div>
            )}
            {model.state.slots.length === 0 && (
              <div style={{ textAlign: 'center' }}>{lang.t('No available slot.')}</div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default SlotCalendar;
